import { AlternateContact, CRUDPermission } from "interface/user"
import { useMemo } from "react"
import { cn } from "styles/cn"
import { prettyprintPhoneNumber, sortByFullName } from "utils/patient"

export function AlternateContactsList({
	alternateContacts,
	permission = "none",
}: {
	alternateContacts?: AlternateContact[] | null
	permission?: CRUDPermission
}) {
	const isPhoneNumberVisible = permission !== "none"
	const visibleContacts = useMemo(
		() =>
			(alternateContacts ?? [])
				.filter(({ isActive }) => (isActive !== undefined ? isActive : true))
				.toSorted(sortByFullName),
		[alternateContacts],
	)

	if (visibleContacts.length === 0) {
		return null
	}

	return (
		<ul
			className={cn("flex flex-col gap-1", isPhoneNumberVisible && "divide-y")}
			aria-label={`${visibleContacts.length} alternate contacts`}
		>
			{visibleContacts.map(
				({ fullName, relationship, phoneNumber, hasCommunications }) => {
					const name = `${fullName} (${relationship})`
					return (
						<li
							key={name}
							className={cn(
								isPhoneNumberVisible && "flex flex-col border-dashed",
							)}
							aria-label={name}
						>
							<span>{name}</span>
							{isPhoneNumberVisible && (
								<span>
									{prettyprintPhoneNumber(phoneNumber, hasCommunications)}
								</span>
							)}
						</li>
					)
				},
			)}
		</ul>
	)
}
